import { Reducer } from 'redux';
import { HistoryState, HistoryActionTypes } from './types';
import { StudentActionTypes, Q } from '../types';
import * as types from 'types';

const initialState: HistoryState = {
  lastCourse: '',
  lastCourseOther: '',
  lastCourseYear: '',
  overseasTravelTimes: '',
  hasPreviousUkStudy: undefined,
  hasPreviousUkStudyVisa: undefined,
  previousUkStudyVisas: [],
  hasOtherUkVisas: undefined,
  otherUkVisas: [],
  borderRefusalReason: '',
  ukVisaRefusals: [],
  otherVisaRefusals: []
};

const reducer: Reducer<HistoryState> = (state = initialState, action): HistoryState => {
  switch (action.type) {
    case StudentActionTypes.GET_STUDENT_RECORD_SUCCESS:
      return {
        ...state,
        ...action.payload.student.history
      };
    case StudentActionTypes.SAVE_PERSONAL_INFO_SUCCESS:
    case StudentActionTypes.SAVE_HISTORY_SUCCESS:
    case StudentActionTypes.SAVE_CONSENTS_SUCCESS:
    case StudentActionTypes.SAVE_PRE_CAS_INTERVIEW_SUCCESS:
    case StudentActionTypes.SAVE_VISA_PREP_FORM_SUCCESS:
    case StudentActionTypes.SAVE_DOCUMENTS_SUCCESS:
    case StudentActionTypes.SAVE_FINANCE_DOCUMENTS_SUCCESS:
      return {
        ...state,
        ...action.payload.history
      };
    case HistoryActionTypes.UPDATE_HISTORY_FIELD:
      switch (action.payload.fieldName) {
        case Q.LAST_COURSE: {
          if (action.payload.value !== 'Other') {
            return {
              ...state,
              [Q.LAST_COURSE_OTHER]: '',
              [action.payload.fieldName]: action.payload.value
            };
          }
          return {
            ...state,
            [action.payload.fieldName]: action.payload.value
          };
        }
        case Q.HAS_OVERSEAS_TRAVEL: {
          if (action.payload.value === false) {
            return {
              ...state,
              [action.payload.fieldName]: action.payload.value,
              [Q.OVERSEAS_TRAVEL_TIMES]: '',
              [Q.HAS_UK_TRAVEL]: undefined,
              [Q.UK_TRAVEL_TIMES]: ''
            };
          }
          return {
            ...state,
            [action.payload.fieldName]: action.payload.value
          };
        }
        case Q.HAS_UK_TRAVEL: {
          if (action.payload.value === false) {
            return {
              ...state,
              [action.payload.fieldName]: action.payload.value,
              [Q.UK_TRAVEL_TIMES]: ''
            };
          }
          return {
            ...state,
            [action.payload.fieldName]: action.payload.value
          };
        }
        case Q.HAS_PREVIOUS_UK_STUDY: {
          if (action.payload.value === false) {
            return {
              ...state,
              [action.payload.fieldName]: action.payload.value,
              [Q.HAS_PREVIOUS_UK_STUDY_VISA]: undefined,
              [Q.PREVIOUS_UK_VISAS]: [],
              [Q.LAST_COURSE_LEVEL]: undefined,
              [Q.REASON_WHY_LOWER_OR_SAME_LEVEL]: ''
            };
          }
          return {
            ...state,
            [action.payload.fieldName]: action.payload.value
          };
        }
        case Q.HAS_PREVIOUS_UK_STUDY_VISA: {
          if (action.payload.value === false) {
            return {
              ...state,
              [action.payload.fieldName]: action.payload.value,
              [Q.PREVIOUS_UK_VISAS]: [],
              [Q.LAST_COURSE_LEVEL]: undefined,
              [Q.REASON_WHY_LOWER_OR_SAME_LEVEL]: ''
            };
          }
          return {
            ...state,
            [action.payload.fieldName]: action.payload.value
          };
        }
        case Q.PREV_UK_OTHER_VISA: {
          if (action.payload.value === false) {
            return {
              ...state,
              [action.payload.fieldName]: action.payload.value,
              [Q.PREV_UK_OTHER_VISAS]: []
            };
          }
          return {
            ...state,
            [action.payload.fieldName]: action.payload.value
          };
        }
        case Q.LAST_COURSE_LEVEL: {
          if ([types.CourseLevel.HIGHER, types.CourseLevel.NO_UK_STUDY].includes(action.payload.value)) {
            return {
              ...state,
              [action.payload.fieldName]: action.payload.value,
              [Q.REASON_WHY_LOWER_OR_SAME_LEVEL]: ''
            };
          }
          return {
            ...state,
            [action.payload.fieldName]: action.payload.value
          };
        }

        case Q.PREVIOUS_VISA_REJECTION: {
          if (action.payload.value === false) {
            return {
              ...state,
              [action.payload.fieldName]: action.payload.value,
              [Q.PREVIOUS_VISA_REJECTION_REASON]: ''
            };
          }
          return {
            ...state,
            [action.payload.fieldName]: action.payload.value
          };
        }
        case Q.PREV_VISA_REFUSAL: {
          if (action.payload.value === false) {
            return {
              ...state,
              [action.payload.fieldName]: action.payload.value,
              [Q.PREV_VISA_REFUSALS]: []
            };
          }
          return {
            ...state,
            [action.payload.fieldName]: action.payload.value
          };
        }
        case Q.PREV_NON_UK_VISA_REFUSAL: {
          if (action.payload.value === false) {
            return {
              ...state,
              [action.payload.fieldName]: action.payload.value,
              [Q.PREV_NON_UK_VISA_REFUSALS]: []
            };
          }
          return {
            ...state,
            [action.payload.fieldName]: action.payload.value
          };
        }

        default:
          return {
            ...state,
            [action.payload.fieldName]: action.payload.value
          };
      }

    default:
      return state;
  }
};

export { reducer as historyReducer };
